import { useCanvasStore } from "@state/canvasStore";
import { useEffect } from "react";
import { ROUTE_CAM_POSITIONS } from "@data/cameraData";

const TheLocation = () => {
  const setCameraData = useCanvasStore((s) => s.setCameraData);

  useEffect(() => {
    setCameraData(ROUTE_CAM_POSITIONS["/the-location"]);
  }, []);

  return null;
};

export default TheLocation;
